import { Injectable } from '@angular/core';
import { ToastMessage, ToastMessageData, ToastMessageOptions } from '@common/models';
import { v4 as uuid } from 'uuid';

@Injectable()
export class ToastService {
    constructor() {}

    toasts: ToastMessage[] = [];
    private readonly defaultOptions: ToastMessageOptions = { autohide: true, delay: 1500 };
    private readonly toastColors: Record<number, ToastMessageOptions> = {
      200: { classes: 'bg-success text-white', headerClasses: 'text-white', bodyClasses: 'text-white' },
      201: { classes: 'bg-success text-white', headerClasses: 'text-white', bodyClasses: 'text-white' },
      400: { classes: 'bg-danger text-white', headerClasses: 'text-white', bodyClasses: 'text-white' },
      401: { classes: 'bg-danger text-white', headerClasses: 'text-white', bodyClasses: 'text-white' },
      403: { classes: 'bg-danger text-white', headerClasses: 'text-white', bodyClasses: 'text-white' },
      404: { classes: 'bg-danger text-white', headerClasses: 'text-white', bodyClasses: 'text-white' },
      409: { classes: 'bg-warning text-dark', headerClasses: 'text-dark', bodyClasses: 'text-dark' },
      500: { classes: 'bg-danger text-white', headerClasses: 'text-white', bodyClasses: 'text-white' }
  };

    show(header: ToastMessageData, body: ToastMessageData, options: ToastMessageOptions = {}): void {
      const toast = { header, body, uuid: uuid(), options: { ...this.defaultOptions, ...options } };
      this.toasts.push(toast);
  
      if (toast.options.autohide) {
        setTimeout(() => this.remove(toast.uuid), toast.options.delay);
      }
    }

  remove(toastID: string) {
      this.toasts = this.toasts.filter(toast => toast.uuid !== toastID);
  }

  showSuccess(message: string) {
      this.show('Success', message, { autohide: true, delay: 1000 });
  }

  showError(message: string) {
      this.show('Failed', message, { autohide: true, delay: 1000 });
  }

  get getToasts() {
      return this.toasts;
  }
}
